import { render, staticRenderFns } from "./roomForm.vue?vue&type=template&id=5be4547f&scoped=true&"
import script from "./roomForm.vue?vue&type=script&lang=js&"
export * from "./roomForm.vue?vue&type=script&lang=js&"
import style0 from "./roomForm.vue?vue&type=style&index=0&id=5be4547f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be4547f",
  null
  
)

export default component.exports